import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AccountQuota } from './account-quota.model';

export const ACCOUNT_QUOTAS_SCHEMA = Object.freeze({
  CLIENTS: AccountQuota,
  PRODUCTS: AccountQuota, // Items
  STORAGE: AccountQuota,
  USERS: AccountQuota,
  DOCUMENTS: AccountQuota,
  INVOICES: AccountQuota,
  PURCHASE_ORDERS: AccountQuota,
  CREDIT_MEMOS: AccountQuota,
  ESTIMATES: AccountQuota,

  // deprecated for v2
  TIME_ENTRIES: AccountQuota, // Items (Labor)
  RECEIPTS: AccountQuota, // Expenses
});
const RECORD = generateSchema(ACCOUNT_QUOTAS_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_QUOTAS_SCHEMA);

export class AccountQuotas extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    return setInModel(this, [
      {
        key: KEYS.CLIENTS,
        value: new AccountQuota(this.clients),
      },
      {
        key: KEYS.PRODUCTS,
        value: new AccountQuota(this.products),
      },
      {
        key: KEYS.STORAGE,
        value: new AccountQuota(this.storage),
      },
      {
        key: KEYS.USERS,
        value: new AccountQuota(this.users),
      },
      {
        key: KEYS.DOCUMENTS,
        value: new AccountQuota(this.documents),
      },
      {
        key: KEYS.INVOICES,
        value: new AccountQuota(this.invoices),
      },
      {
        key: KEYS.PURCHASE_ORDERS,
        value: new AccountQuota(this.purchaseOrders),
      },
      {
        key: KEYS.CREDIT_MEMOS,
        value: new AccountQuota(this.creditMemos),
      },
      {
        key: KEYS.ESTIMATES,
        value: new AccountQuota(this.estimates),
      },
      {
        key: KEYS.TIME_ENTRIES,
        value: new AccountQuota(this.timeEntries),
      },
      {
        key: KEYS.RECEIPTS,
        value: new AccountQuota(this.receipts),
      },
    ]) as AccountQuotas;
  }

  get clients(): AccountQuota {
    return this.get(KEYS.CLIENTS);
  }

  get products(): AccountQuota {
    return this.get(KEYS.PRODUCTS);
  }

  // unit of value is in bytes
  get storage(): AccountQuota {
    return this.get(KEYS.STORAGE);
  }

  get users(): AccountQuota {
    return this.get(KEYS.USERS);
  }

  get documents(): AccountQuota {
    return this.get(KEYS.DOCUMENTS);
  }

  get invoices(): AccountQuota {
    return this.get(KEYS.INVOICES);
  }

  get purchaseOrders(): AccountQuota {
    return this.get(KEYS.PURCHASE_ORDERS);
  }

  get creditMemos(): AccountQuota {
    return this.get(KEYS.CREDIT_MEMOS);
  }

  get estimates(): AccountQuota {
    return this.get(KEYS.ESTIMATES);
  }

  // deprecated for v2
  get timeEntries(): AccountQuota {
    return this.get(KEYS.TIME_ENTRIES);
  }

  // deprecated for v2
  get receipts(): AccountQuota {
    return this.get(KEYS.RECEIPTS);
  }

  canCreate(accountQuotaKey: string): boolean {
    return (this.get(accountQuotaKey) as AccountQuota).canCreate;
  }
}
